<template>
    <div class="list">
        <NavBar></NavBar>
        <van-col span='24' style="font-size:16px;font-weight:bold;text-align:center;padding-top:7px">关于{{regionName}}维修项目的业主表决公告</van-col>
        <van-cell title="基本信息" :value="startPublicityDate" />
        <div class="card_content">
            <div class="card_son">
                <van-col span='24' style="font-size:13px">维修项目名称：{{obj.reqName}}</van-col>
                <van-col span='24' style="font-size:13px;margin:7px 0">维修项目类型：{{obj.projectType=='1'?'正常项目':obj.projectType=='2'?'应急项目':''}}</van-col>
                <van-col span='24' style="font-size:13px">分摊方式：{{obj.marginType}}</van-col>
                <van-col span='24' style="font-size:13px;margin:7px 0">维修类别：{{obj.maintainTypeName}}</van-col>
                <van-col span='24' style="font-size:13px">申请单位：{{obj.orgType=='1'?obj.orgReqName:obj.orgType=='2'?obj.orgOwner:''}}</van-col>
                <van-col span='24' style="font-size:13px;margin:7px 0">施工单位：{{obj.orgConstructionName}}</van-col>
                <van-col span='24' style="font-size:13px">表决开始时间：{{startPublicityDate}}</van-col>
                <van-col span='24' style="font-size:13px;margin:7px 0">表决截止时间：{{obj.endVoteDate}}</van-col>
                <van-col span='24' style="font-size:13px">预算金额（元）：{{obj.budgSum}}</van-col>
                <van-col span='24' style="font-size:13px;margin:7px 0">分摊总户数：{{obj.allUser}}</van-col>
                <van-row gutter="20">
                    <van-col span='12' style="font-size:13px;">分摊总面积(㎡)：{{obj.allArea}}</van-col>
                    <van-col span='12' style="color:blue;font-size:13px;text-align:right" @click="openShare">查看分摊清册</van-col>
                </van-row>
            </div>
        </div>
        <!-- 勘查图片 -->
        <van-cell value="勘查图片" />
        <div v-if="isShow1">
            <van-empty image="error" description="暂无图片" />
        </div>
        <!-- <div v-if="!isShow1" class="card_content">
            <div class="card_son">
                <div v-for="(item,index) in imgList" :key="index" style="margin-bottom:10px">
                    <van-image  width="100%" :src="item" @click="openImg(index)"/>
                </div>
            </div>
        </div> -->
        <!-- 查看图片新的写法 -->
        <div v-if="!isShow1" class="card_content">
            <div class="card_son">
                <div v-for="(item,index) in imgList" :key="index" style="margin-bottom:10px">
                    <van-image  width="100%" :src="item" @click="openImg(index)">
                        <van-image-preview v-model:show="show2" :images="imgList" :startPosition='startPosition'>
                        </van-image-preview>
                    </van-image>
                </div>
            </div>
        </div>
        <!--表决结果 -->
        <van-cell value="表决结果" />
        <div class="card_content">
            <div class="card_son">
                <van-form >
                    <div v-if="opinion1=='2'&&voteState=='2'">
                        <!-- <Agreeviting v-model="radio"></Agreeviting> -->
                        <van-field name="radio">
                            <template #input>
                                <van-radio-group v-model="radio" direction="horizontal">
                                    <van-radio icon-size="16px" name="0">同意</van-radio>
                                    <van-radio icon-size="16px" name="1">不同意</van-radio>
                                    <van-radio icon-size="16px" name="3">弃权</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>
                        <van-col span='24' style="font-size:13px;color:gray;margin-left:15px;margin-top:5px">表决截止时间：{{obj.endVoteDate}}</van-col>
                    </div>
                    <div v-if="opinion1=='0'||opinion1=='1'||opinion1=='3'||voteState=='3'||voteState=='4'">
                        <div class="wrapper">
                            <div class='chart' ref='dom' id='chart'></div>
                            <!-- <Charts></Charts> -->
                            <div style="clear:both"></div>
                            <div v-if="opinion1=='0'||opinion1=='1'||opinion1=='3'">
                                <van-row justify="space-between" style="margin-bottom:10px">
                                    <van-col span='16' style="font-size:13px;color:gray">表决人：{{realName}}</van-col>
                                    <van-col span='8' style="font-size:17px;font-weight:bold;color:gray;text-align:center;color:orange">
                                        {{opinion1=='0'?'同意':opinion1=='1'?'不同意':opinion1=='3'?'弃权':''}}
                                    </van-col>
                                </van-row>
                                <van-row justify="space-between">
                                    <van-col span='16' style="font-size:13px;color:gray">表决时间：{{voteDate}}</van-col>
                                    <van-col span='8' style="font-size:13px;color:gray;text-align:center">我的表决</van-col>
                                </van-row>
                            </div>
                        </div>
                    </div>
                    <!-- <div v-if="voteState=='4'">
                        <div style="font-size:20px;font-weight:bold;color:gray;text-align:center;padding:15px 0">已过期</div>
                    </div> -->
                    <div v-if="opinion1=='2'&&voteState=='1'">
                        <div style="font-size:20px;font-weight:bold;color:gray;text-align:center;padding:15px 0">公示中</div>
                    </div>
                    <!--  -->
                </van-form>
            </div>
        </div>
        <div style="padding:25px 0"></div> 
        <div class="bottom_flex1" v-show="hidshow" v-if="opinion1=='2'&&voteState=='2'">
            <van-row  class="secondFlex">
                <van-col :span="24" class="owerviting">
                    <van-checkbox style="width:50px" v-model="checked" >
                    </van-checkbox>
                    <span>
                        我已知晓并理解维修资金项目表决的意义及方法。
                        <span style="color:#428bca" @click="openArgeement">《维修资金表决操作说明》</span>
                    </span>
                </van-col>
            </van-row>
            <div class="flexed">
                <!-- <van-button color="#e1251b" size="normal" @click="onSubmit" :disabled='!checked'>提交表决结果{{radio=='1'?"(同意)":radio=='2'?'(不同意)':radio=='3'?'(弃权)':''}}</van-button> -->
                <van-button color="#e1251b" size="normal" @click="onSubmit" :disabled='!checked'>提交表决结果</van-button>
            </div>
        </div>
        <!-- <div style="padding:10px">
            <van-button color="#e1251b" block size="normal">返 回</van-button>
        </div> -->
        <!-- <div style="padding:55px 0"></div> -->
        <!-- 协议弹框 -->
        <van-dialog v-model:show="agreement" title="操作说明" show-cancel-button :show-confirm-button='false'>
            <div style="padding:10px 15px;font-size:14px;height:300px;overflow:auto" v-html="contentss">
                
            </div>
        </van-dialog>
        <!-- 分摊清册弹框 -->
        <van-dialog v-model:show="inmation" title="维修资金预分摊清册" show-cancel-button :show-confirm-button='false'>
            <div style="padding:10px 15px;font-size:14px;height:250px;overflow:auto">
                <van-col span='24'>汇总信息</van-col>
                <van-col span='24' style="margin:15px 0">总户数：{{obj.allUser}}</van-col>
                <van-col span='24'>业主自交户数：{{obj.selfSum}}</van-col>
                <van-col span='24' style="margin:15px 0">预算金额(元)：{{obj.budgSum}}</van-col>
                <van-col span='24'>自交金额(元)：{{obj.selfAmount}}</van-col>
                <van-col span='24' style="margin:15px 0">分摊面积(㎡)：{{obj.allArea}}</van-col>
                <table border="1" cellspacing='0' cellpadding='10' style="width:100%">
                    <tr>
                        <th>房屋坐落</th>
                        <th>分摊金额</th>
                    </tr>
                    <tr style="font-size:12px;" v-for="item in list" :key="item">
                        <td>{{item.houseSite}}</td>
                        <td style="text-align:center">{{item.assiAmount}}元</td>
                    </tr>
                </table>
            </div>
        </van-dialog>
        <!--  -->
    </div>
</template>

<script>
// import Charts from '@/components/Owners/chartsvoting.vue'
import VueCookie from 'vue-cookie'
import echarts from 'echarts'
import { createApp } from 'vue';
import { ImagePreview } from "vant";
export default {
    // components:{
    //     Agreeviting
    //     Charts
    // },
    data(){
        return {
            show2:false,
            startPosition:'',
            contentss:`<p><b></b>威海市南海新区物业专项维修资金一次性表决使用程序<br></p><p><o:p>&nbsp;</o:p></p><p>一、一般规定</p><p>1.1物业专项维修资金一次性表决使用应按申请受理、现场勘查、业主表决、审核、公示、拨款的程序办理。</p><p>1.2一次性表决使用物业专项维修资金应当具备下列条件:</p><p>1.2.1表决范围内全体业主受益</p><p>1.2.2一次性表决使用物业专项维修资金,当专有部分占建筑物总面积1/3以下的业主且占总人数1/3(以下简称“异议表决")以下的业主表决不同意，则本次表决通过。</p><p>二、表决限制</p><p>2.1身份限制</p><p>2.1.1表决人应为该维修项目表决范围内房屋的当前业主，业主表决前有义务提供表决房屋的所有权以完成业主绑定认证，无法提供房屋所有权证明的无法参与表决。</p><p>2.1.2表决范围内每个房屋最多仅占一票表决权，每个房屋当前业主有权行使表决操作。当房屋包含多个业主时，仅允许最先参与表决（最先点击提交表决意见）的业主参与表决。</p><p>2.2时间限制</p><p>2.2.1维修资金表决分为公示期、表决期、表决结束三个阶段。</p><p>2.2.2公示期可以查看表决详情，但不可提交表决意见。</p><p>2.2.3表决期可以提交一次性表决意见，但不可修改。</p><p>2.2.4表决结束后进行计票并最终形成表决结果（通过、不通过），仅可查看表决详情，如尚未提交表决意见的，则不可继续提交。</p><p>三、异议反馈</p><p>3.1当表决结束后，其他房屋业主对该次表决有异议的，应当在表决结束后5个工作日内联系南海维修资金（详情见账户中心-联系我们），填报申请材料，工作人员将在审核后反馈意见。</p><p>3.2当表决结束后，房屋共有业主对该次表决意见有异议的，应当在表决结束后5个工作日内联系南海维修资金（详情见账户中心-联系我们），征得该房屋所有共有业主同意并填报申请材料，工作人员将在审核后反馈意见。</p>`,
            voteDate:'',
            regionName:'',
            opinion2:'',
            realName:'',
            votePass:'',
            voteUnPass:'',
            opinion1:'',
            voteState:'',
            startPublicityDate:'',
            isShow1:false,
            list:[],
            obj:{},
            roomNo:'',
            reqId:'',
            math:'',
            abc:Number,
            bcd:Number,
            isShow:true,
            agreement:false,
            checked:false,
            contents:'',
            radio:'0',
            inmation:false,
            isLoading:false,
            // documentHeight: document.documentElement.clientHeight, //默认屏幕的高度
            screenHeight: document.documentElement.clientHeight, //一个默认屏幕的高度 一个实时屏幕的高度  下面监听并判断一下
            originHeight: document.documentElement.clientHeight,
            hidshow:true,  //显示或者隐藏footer
            instance_after:'',
            imgList:[],
        }
    },
    // beforeRouteEnter(to,from,next){
    //     console.log(to)
    //     next()
        
    // },
    /**
     * 在切换路由或者关闭路由的时候关闭预览图片的遮罩
     */
    beforeRouteLeave(to,from,next){
        this.$nextTick(()=>{
            if(this.inmation||this.show2){
                this.show2 = false
                this.inmation = false
                next(false)
            }else if(!this.show2||!this.inmation){
                next(true)
            }
        })
    },
    // beforeRouteLeave(to,from,next){
    //     this.$nextTick(()=>{
    //         if(this.math=='1'){
    //             this.instance_after.close()
    //         }
    //         if(this.inmation){
    //             this.inmation = false
    //         }
    //     })
    //     next()
    // },
    mounted(){
        // this.ResultsStatistics()
        // console.log(this.voteUnPass,'44444444444444')
        // this.drawChart()
        let self = this;
        window.onresize = function() {
            return (function(){
                self.screenHeight = document.documentElement.clientHeight;
            })()
        }
    },
    watch:{
        screenHeight (val) {
            if(this.originHeight > val + 100) {        //加100为了兼容华为的返回键
                this.hidshow = false;
            }else if(this.originHeight == val ){
                this.hidshow = true
            }else{
                this.hidshow = true;
            }
        }
    },
    methods:{
        /**
         * ajax给echarts图表赋值的东西 投票结果统计
         */
        ResultsStatistics(){
            let data={
                roomNo:this.roomNo,
                reqId:this.reqId
            }
            this.$postQuery('/WeChat/getVoteResult', data).then((response)=>{
                console.log(response)
                if(response.code==200){
                    this.voteUnPass = parseInt(response.data.voteUnPass)
                    this.votePass = parseInt(response.data.votePass)
                    this.realName = response.data.realName
                    this.opinion2 = response.data.opinion
                    this.voteDate = response.data.voteDate
                    //在这调echarts接口  其他地方调在里面不显示数据
                    this.drawChart()
                }
            })
        },
        /**
         * echarts图表
         */
        drawChart(){
            // console.log(this.$refs.dom,'qqqqqqqqqqqqq')
            //先判断一下  如果没有chart实例的时候就不执行下面的了 否则会报错 如果有实例的话就往下赋值数据
            if(!this.$refs.dom){
                return
            }
            // console.log(this.voteUnPass,'wwwwwwwww')
            // 基于准备好的dom，初始化echarts实例
            let chart = echarts.init(document.getElementById('chart'))
            // 监听屏幕变化自动缩放图表
            window.addEventListener('resize', function () { chart.resize() })
            // 绘制图表
            chart.setOption({
                // padding: 5,
                color: ['#009ae4', '#e1251b'],
                grid: {
                    top:15,
                    bottom:0,
                    left:0,
                    right:0,
                    containLabel: true // grid 区域是否包含坐标轴的刻度标签, 常用于『防止标签溢出』的场景
                },
                // 图例组件
                legend: {
                    textStyle: { // 文本样式
                        fontSize: 12,
                        // color: 'rgb(61, 60, 60)'
                        color:'gray'
                    },
                top: 0, // 定位
                data: [ '同意/弃权', '不同意'] // 图例的数据数组
                },
                // X轴
                xAxis: {
                    type: 'value', // 坐标轴类型,   'value' 数值轴，适用于连续数据
                    // type: 'category',
                    // 坐标轴刻度
                    axisTick: {
                        show: false // 是否显示坐标轴刻度 默认显示
                    },
                    // 坐标轴轴线
                    axisLine: { // 是否显示坐标轴轴线 默认显示
                        show: false // 是否显示坐标轴轴线 默认显示
                    },
                    // 坐标轴在图表区域中的分隔线
                    splitLine: {
                        show: false // 是否显示分隔线。默认数值轴显示
                    },
                    // 坐标轴刻度标签
                    axisLabel: {
                        show: false // 是否显示刻度标签 默认显示
                    }
                },
                yAxis: [
                    // 左侧Y轴
                    {
                        // 坐标轴类型,  'category' 类目轴，适用于离散的类目数据
                        // 为该类型时必须通过 data 设置类目数据
                        type: 'category', 
                        // 坐标轴刻度
                        axisTick: {
                        show: false // 是否显示坐标轴刻度 默认显示
                        },
                        // 坐标轴轴线
                        axisLine: { // 是否显示坐标轴轴线 默认显示
                            show: false, // 是否显示坐标轴轴线 默认显示
                        // lineStyle: { // 坐标轴线线的颜色
                        //     color: '#cdd3ee'
                        // }
                        },
                        // 坐标轴在图表区域中的分隔线
                        splitLine: {
                            show: false // 是否显示分隔线。默认数值轴显示
                        },
                        // 坐标轴刻度标签
                        axisLabel: {
                            show: true, // 是否显示刻度标签 默认显示
                            fontSize: 12, // 文字的字体大小
                            color: 'gray', // 刻度标签文字的颜色
                            // 使用字符串模板，模板变量为刻度默认标签 {value}
                            // formatter: '{value}'
                        },
                        // 类目数 据，在类目轴（type: 'category'）中有效
                        data: [''] 
                    }
                ],
                 // 系列列表
                series: [
                    {
                        type: 'bar', // 系列类型
                        name: '同意/弃权', // 系列名称, 用于tooltip的显示, legend 的图例筛选
                        // 数据堆叠，同个类目轴上系列配置相同的stack值后，后一个系列的值会在前一个系列的值上相加
                        stack: '总量',
                        barMaxWidth: 30, // 柱条的最大宽度，不设时自适应
                        // 图形上的文本标签
                        label: {
                        show: true,
                        // 标签的位置 left right bottom top inside  // 绝对的像素值 position: [10, 10] 
                        // 相对的百分比 position: ['50%', '50%']
                        position: 'inside' ,
                        // formatter:'同意/弃权({c})'
                        },
                        // 图形样式
                        itemStyle: {
                            barBorderRadius: [0, 0, 0, 0] // 圆角半径, 单位px, 支持传入数组分别指定 4 个圆角半径
                        },
                        data: [this.votePass] // 系列中的数据内容数组
                    },
                    {
                        type: 'bar', // 系列类型
                        name: '不同意', // 系列名称, 用于tooltip的显示, legend 的图例筛选
                        // 数据堆叠，同个类目轴上系列配置相同的stack值后，后一个系列的值会在前一个系列的值上相加
                        stack: '总量',
                        barMaxWidth: 30, // 柱条的最大宽度，不设时自适应
                        // 图形上的文本标签
                        label: {
                            show: true,
                            // 标签的位置 left right bottom top inside  // 绝对的像素值 position: [10, 10] 
                            // 相对的百分比 position: ['50%', '50%']
                            position: 'inside' ,
                            // formatter:'不同意({c})'
                        },
                        // 图形样式
                        itemStyle: {
                            barBorderRadius: [0, 0, 0, 0] // 圆角半径, 单位px, 支持传入数组分别指定 4 个圆角半径
                        },
                        data: [this.voteUnPass] // 系列中的数据内容数组
                    },
                ]
            })
        },
        /**
         * 详情信息
         */
        ReqDetail(){
            let data={
                id:this.reqId
            }
            this.$postQuery('/WeChat/getReqDetailById', data).then((response)=>{
                if(response.code==200){
                    this.obj = response.data
                    response.data.surveyFileList.forEach((item)=>{
                        // console.log(item,'11111111111')
                        //URL是从axios里面获取到的
                        // item = this.Url+item
                        item = 'http://nhzjwxzj.weihai.cn'+item
                        // item =  'http://ytwyw.cn'+item
                        this.imgList.push(item)
                        // console.log(item)
                    })
                    // console.log([...this.imgList])
                    if(this.imgList.length==0){
                        this.isShow1=true
                    }
                }
            })
        },
        /**
         * 点击提交
         */
        onSubmit(){
            // console.log(this.radio)
            // var opinion = this.radio
            // console.log(opinion)
            let data = {
                openId:VueCookie.get('openid'),
                // openId:'o5AgcxDoREhPpdd0wzkSYvfnSKmQ',
                roomNo:this.roomNo,
                reqId:this.reqId,
                opinion:this.radio
            }
            this.$postQuery('/WeChat/submitVote', data).then((response)=>{
                if(response.data.data==200){
                    this.$toast('投票成功!')
                    // history.go(-1)
                    this.$router.replace({
                        path:'/MyVote'
                    })
                    this.$router.go(-1)
                }else{
                    this.$toast('投票失败!')
                }

            })
        },
        /**
         * 点击图片预览
         */
        openImg(index){
            // this.math = '1'
            // this.instance_after = ImagePreview({
            //     images:this.imgList,
            //     startPosition: index,
            //     closeable: true,
            //     closeOnPopstate:true,
            // });
            this.show2 = true
            this.startPosition = index
        },
        /**
         * 查看分摊清册
         */
        openShare(){
            this.inmation = true;
            let data = {
                id:this.reqId,
                pageNum:1,
                pageSize:100
            }
            this.$postQuery('/WeChat/getApportionmentList', data).then((response) => {
                console.log(response)
                if(response.code==200){
                    this.list = response.data.list
                }
            })
        },
        /**
         * 查看协议
         */
        openArgeement(){
            this.agreement = true;
        }
    },
    created(){
        const app = createApp();
        app.use(ImagePreview);
        this.roomNo = this.$route.query.roomNo
        this.reqId = this.$route.query.reqId
        this.startPublicityDate = this.$route.query.startPublicityDate
        this.voteState = this.$route.query.voteState
        this.opinion1 = this.$route.query.opinion1
        this.regionName = this.$route.query.regionName
        this.ReqDetail()
        this.ResultsStatistics()
    }
}
</script>

<style scoped>
.list {
    margin-top: 46px;
}
.card_content{
    padding: 0 10px 0px 10px;
}
.card_son{
    border: 1px solid #ebedf0;
    padding: 10px;
    box-shadow: 2px 3px 12px #ebedf0;
}
.flexed{
  margin: 10px;
}
.flexed .van-button,.content_button .van-button{
  padding: 3px 15px;
  width: 100%;
}
.secondFlex{
    /* position: fixed;
    left: 0;
    bottom: 50px; */
    padding: 0 10px;
    /* display: flex; */
    /* align-items: center; */
    /* justify-content: space-around; */
}
.owerviting{
    font-size: 13px;
    line-height: 18px;
    display: flex;
    align-items: center;
}
.bottom_flex1{
    /* position: fixed; */
    /* bottom: 0; */
    /* left: 0; */
    width: 100%;
    padding-top: 10px;
    background-color: rgba(255, 255,255, 0.9);
}
.wrapper {
  width: 100%;
}
.wrapper .chart {
  width: 100%;
  /* height: 50px; */
  height:70px;
  /* color: rgb(61, 60, 60); */
  /* margin: 100px auto 0; */
  /* background: url(../../public/static/bg.png) no-repeat; */
  /* background-size: 100% 100%; */
}
</style>